import { createContext, useContext, ReactNode } from 'react';
import { useLocalStorage } from '@mantine/hooks';
import { SidebarState } from '@/types';

interface SidebarContextType {
  sidebarState: SidebarState;
  setSidebarState: (state: SidebarState) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const getDefaultState = () => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 768 ? 'hidden' : 'full';
    }
    return 'full';
  };

  const [sidebarState, setSidebarState] = useLocalStorage<SidebarState>({
    key: 'mantine-nav-state',
    defaultValue: getDefaultState(),
  });

  return (
    <SidebarContext.Provider value={{ sidebarState, setSidebarState }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
